import React, { FC } from 'react';
import { MixpanelEvents } from 'integrations/mixpanel/Events/MixpanelEvents';
import { useMixpanel } from 'integrations/mixpanel/useMixpanel';
import { ExportEventDetails } from 'integrations/mixpanel/Events/general';
import { DataTablePluginExporter } from '@utmost.co/utmost-design-system';
import { useExportsTo } from 'src/utils/hooks/data/exports/useExportsTo';
import { ExportSource } from 'src/utils/hooks/data/exports/utils/Exports.types';
import { JobFamilyGroupQueryModelInput, OcCsvExportQueryModelInput } from 'src/graphql/types';
import { useJobCataloguesIntl } from '@oc/pages/settings/Engagements/JobCatalogues/translations/useJobCataloguesIntl';

type JobFamilyGroupFilterModel = Omit<Partial<JobFamilyGroupQueryModelInput>, 'search'> & { search?: string };

export const JobFamilyGroupsExporter: FC = () => {
  const { track } = useMixpanel();
  const intl = useJobCataloguesIntl();
  const exportJobFamilyGroups = useExportsTo();

  return (
    <DataTablePluginExporter<JobFamilyGroupFilterModel>
      exportFileFormats={['CSV', 'XLSX']}
      onExport={(quickReport, fileFormat, source, quickReportName) => {
        const mode = fileFormat === 'CSV' ? 'batch-csv' : 'batch-excel';
        track<ExportEventDetails>(MixpanelEvents.general.EXPORT, {
          exportType: mode,
          exportEntity: 'job_family_group',
          origin: source ?? 'unknown'
        });
        exportJobFamilyGroups({
          query: { jobFamilyGroups: {} as OcCsvExportQueryModelInput['jobFamilyGroups'] },
          mode,
          reportName: intl.jobFamilyGroups,
          source: ExportSource.JobFamilyGroups
        });
      }}
      onOpen={() => {
        track(MixpanelEvents.quickReport.CHIP_OPEN_EXPORT_MENU_CLICK, { view: 'Job Family Groups' });
      }}
    />
  );
};
